/* eslint-disable react/no-find-dom-node */
import React, { useContext } from 'react';
import { findDOMNode } from 'react-dom';
import { FocusTrapContext } from './FocusTrapContext';
// This needs to use findDOMNode() to emulate FocusTrap's behavior, and
// findDOMNode() requires React.Component.
class FocusTrapChildImpl extends React.PureComponent {
    constructor(props) {
        super(props);
        this.prevElem = null;
    }
    componentDidMount() {
        const { register } = this.props;
        const elem = findDOMNode(this);
        if (elem instanceof HTMLElement) {
            this.prevElem = elem;
            register(elem);
        }
    }
    componentDidUpdate() {
        const { register, unregister } = this.props;
        const elem = findDOMNode(this);
        if (elem instanceof HTMLElement && elem !== this.prevElem) {
            if (this.prevElem != null) {
                unregister(this.prevElem);
            }
            this.prevElem = elem;
            register(elem);
        }
    }
    componentWillUnmount() {
        const { unregister } = this.props;
        if (this.prevElem != null) {
            unregister(this.prevElem);
            this.prevElem = null;
        }
    }
    render() {
        const { children } = this.props;
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        React.createElement(React.Fragment, null, children));
    }
}
export function FocusTrapChild(props) {
    const context = useContext(FocusTrapContext);
    return (React.createElement(FocusTrapChildImpl, Object.assign({}, props, context)));
}
//# sourceMappingURL=FocusTrapChild.js.map